
export const FETCH_CART = 'FETCH_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const DELETE_CART = 'DELETE_CART';
export const CREATE_CART = 'CREATE_CART';
export const UPDATE_CART_SUCCESS = 'UPDATE_CART_SUCCESS';
export const UPDATE_CART_FAIL = 'UPDATE_CART_FAIL';



// WEBPACK FOOTER //
// ./src/data/carts/types.js